<template>
  <div id="permission">
    <el-tabs tabPosition="left" class="groups-list" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        v-for="(group,groupIndex) in feature.groups"
        :key="groupIndex"
        :label="group.displayName"
        :name="group.displayName"
        tab-position="left"
      ></el-tab-pane>
    </el-tabs>
    <el-form class="el-form" v-if="feature">
      <div
        v-for="(group,groupIndex) in feature.groups"
        :key="groupIndex"
        class="form-li"
        v-show="group.displayName==activeName"
      >
        <div class="table-tit">
          <div class="table-val">
            <div class="table-name">{{group.displayName}}</div>
          </div>
          <div class="table-tips">说明</div>
        </div>
        <div
          class="table-info"
          v-for="(permission,permissionsIndex) in group.permissions"
          :key="permissionsIndex"
        >
          <div class="table-val">
            <div class="table-name">{{ permission.displayName }}</div>
            <div class="table-operation" v-if="permission.isDropdownBox">
              <el-dropdown @command="handleCommand" trigger="click" placement="bottom">
                <span class="el-dropdown-link">
                  {{permission.selectedScope|typeFile}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="opertion-dropdown">
                  <el-dropdown-item
                    v-for="scope in permission.scopes"
                    :key="scope.name"
                    :command="beforeHandleCommand(permission,scope.name)"
                  >
                    <span>{{scope.displayName}}</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <el-select
                @change="changeFeatures(permission,permission.selectedScope)"
                v-model="permission.selectedScope"
              >
                <el-option
                  v-for="scope in permission.scopes"
                  :key="scope.name"
                  :label="scope.displayName"
                  :value="scope.name"
                ></el-option>
              </el-select>-->
            </div>
            <div class="table-operation" v-else>
              <el-switch
                v-model="permission.selectedScope"
                active-value="Granted"
                inactive-value="Prohibited"
                :disabled="isDisabled"
                @click.native="showDisable"
                @change="changeSelectedScope(permission.selectedScope,permission)"
              ></el-switch>
            </div>
          </div>
          <div class="table-tips">{{permission.description}}</div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getFeatures, updateFeatures } from "@/http/api/features";
import { debounce } from "@/utils/debounce";


export default {
  props: {
    id:{type:String}
  },
  data() {
    return {
      feature: {},
      activeName: "身份标识管理",
      permissionList: this.$store.getters.permissions, //用户功能集合
      isDisabled: true,
    };
  },
  created() {
    this.$watch(
      "id",
      debounce((val) => {
        this.getFeaturesInfo();
        //console.log(1111);
      }, 200)
    );
  },
  mounted() {
    // this.getPermissionsInfo();
    this.isDisabled = !this.permissionList["RocketIdentity.Roles.ManagePermissions"];
  },
  methods: {
    showDisable() {
      if (this.isDisabled) {
        this.$message.warning({
          message: `您暂无配置权限`,
          showClose: true,
        });
      }
    },
    changeSelectedScope(val, item) {
      this.changeFeatures(item, val);
    },
    handleClick(val) {},
    beforeHandleCommand(row, command) {
      return {
        row: row,
        command: command,
      };
    },
    handleCommand(command) {
      if (!this.isDisabled) {
        this.changeFeatures(command.row, command.command);
        // if (command.command == "发布") {
        //   showStatusChange(command.row, "Published");
        // } else if (command.command == "取消发布") {
        //   this.preview(command.row);
        // } else if (command.command == "删除") {
        //   this.openDeleted(command.row);
        // } else if (command.command == "日志") {
        //   this.toHistory(command.row);
        // }
      } else {
        this.$message.warning({
          message: `您暂无配置功能`,
          showClose: true,
        });
      }
    },
    getFeaturesInfo() {
      var query={
        providerName:"T",
        providerKey:this.id,
      }
      getFeatures(query).then((res) => {
        this.feature = res.result;
      });
    },

    changeFeatures(permission, selectedScope) {
      //console.log(permission, selectedScope, 222222222);
      var data = {
        permissions: [
          {
            name: permission.name,
            scope: selectedScope,
          },
        ],
      };
      updateFeatures(this.$store.getters.generateUpdateSettingsParams, data).then((res) => {
        this.getFeaturesInfo();
        this.$store.dispatch("ChangePermissions");
        if (res) {
          this.$message.success({ message: "配置更新成功", showClose: true });
        }
      });
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#permission {
  padding: 30px 0 0;
  @include flex(row, flex-start);
  text-align: left;
  ::v-deep .groups-list {
    .el-tabs__nav-scroll {
      padding-left: 0;
    }
    .el-tabs__item {
      font-size: 12px;
    }
    .el-tabs__active-bar {
      padding: 0;
      right: 0;
      left: auto;

      color: #fff;
      background: #fff;
    }
  }
  .el-form {
    width: 80%;
    .form-li {
      position: relative;
      margin-bottom: 35px;
      // padding-top: 20px;
      // border: 1px dashed #dddddd;
      .table-tit,
      .table-info {
        @include flex(row, center);
        background: #f1f1f1;
        .table-val {
          @include flex(row, center);
          justify-content: space-between;
          border-bottom: 1px solid #dfdfdf;
          border-left: 1px solid #dfdfdf;
          padding: 10px 10px;
          width: 50%;
          height: 20px;
          line-height: 20px;
          .table-name{
            width: 85%;
            overflow: hidden;
          }
          .table-operation {
            cursor: pointer;
          }
        }
        .table-tips {
          padding: 10px 10px;
          border-left: 1px solid #dfdfdf;
          border-right: 1px solid #dfdfdf;
          border-bottom: 1px solid #dfdfdf;
          width: 50%;
          height: 20px;
          line-height: 20px;
        }
      }
      .table-tit {
        border-top: 1px solid #dfdfdf;
      }
      .table-info {
        background: #fff;
      }
    }
  }
}
</style>
